import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AbstractComponentFlow } from './AbstractComponentFlow';
import { ManifestComponentExtensionType } from '../ManifestStore';
import { PanelStore } from '../PanelStore';
export class SystemComponentFlow extends AbstractComponentFlow {
  constructor() {
    super(...arguments);
    /**
     * System components are components that are predefined in the store and do not require a manifest to be loaded.
     */
    _defineProperty(this, "type", ManifestComponentExtensionType.SYSTEM);
    _defineProperty(this, "systemComponentAppData", this.dm.platform.getAppDataByAppDefId(SystemComponentFlow.SYSTEM_APP_DEF_ID));
  }
  async loadManifest() {
    // Empty implementation for system components because manifests predefined in the store
  }
  async loadPanels() {
    // Empty implementation for system components because panels predefined in the store
  }
  async loadPanelsByCompType(_ref) {
    let {
      compType
    } = _ref;
    const manifest = this.manifestStore.getManifest(compType);
    if (!manifest || !manifest.editorElement) {
      return;
    }
    const panels = await this._loadPanels(manifest.editorElement, this.systemComponentAppData);
    Object.keys(panels).forEach(actionName => {
      this.panelStore.setPanel(compType, actionName, panels[actionName]);
    });
    const tree = this.manifestHelpers.structure.getChildrenElementManifests(manifest);
    Object.keys(tree).map(async innerPath => {
      const _panels = await this._loadPanels(manifest, this.systemComponentAppData);
      Object.keys(_panels).forEach(actionName => {
        this.panelStore.setPanel(PanelStore.getPanelId(compType, innerPath.split('.')), actionName, _panels[actionName]);
      });
    });
  }
}
_defineProperty(SystemComponentFlow, "SYSTEM_APP_DEF_ID", '88110a9d-ba44-450e-bcf9-17058af00b76');
//# sourceMappingURL=SystemComponentFlow.js.map